module.exports = __webpack_public_path__ + "static/media/on-off_icon.1bc8580a.svg";